import React from "react";
import { View, Text, StyleSheet, Dimensions, Platform } from "react-native";
import LhButton from "../../components/LhButton";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import FontFamily from "../../constants/fonts";
import { useTheme } from "../../theme";

// Props for SparcWalkWelcome component
interface SparcWalkWelcomeProps {
  openFilterOverlay: () => void;
  clearWalk: () => void;
}

const SparcWalkWelcome: React.FC<SparcWalkWelcomeProps> = ({
  openFilterOverlay,
  clearWalk,
}) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  // Helper function to check if device is in mobile layout
  const isMobileView = () => {
    const windowWidth = Dimensions.get("window").width;
    return (
      Platform.OS === "ios" || Platform.OS === "android" || windowWidth < 768
    );
  };

  // Helper function to check if device is a very small mobile device
  const isVerySmallMobileView = () => {
    const windowWidth = Dimensions.get("window").width;
    return (
      (Platform.OS === "ios" || Platform.OS === "android") && windowWidth < 375
    );
  };

  // Helper function to check if device is iOS mobile (not iPad or web)
  const isIOSMobile = () => {
    const windowWidth = Dimensions.get("window").width;
    const windowHeight = Dimensions.get("window").height;
    const isSmallScreen = windowWidth < 768 && windowHeight < 1024;
    return Platform.OS === "ios" && isSmallScreen;
  };

  // Determine whether to show button text based on screen size
  const showButtonText = !isVerySmallMobileView();

  return (
    <View style={styles.welcomeCard}>
      <View
        style={
          isIOSMobile()
            ? styles.welcomeContainerIOSMobile
            : styles.welcomeContainer
        }
      >
        <View style={styles.welcomeLeftContent}>
          <Text style={[styles.welcomeText, { color: isDark ? "#FFFFFF" : "#000000" }]}>SPARC Walk Dashboard</Text>
        </View>
        <View
          style={
            isIOSMobile()
              ? styles.beginButtonRowIOSMobile
              : isMobileView()
              ? styles.beginButtonRowMobile
              : styles.beginButtonRow
          }
        >
          <LhButton
            text={showButtonText ? "Begin" : ""}
            variant="primary"
            size="small"
            iconTrailing="arrow-forward"
            iconSize={20}
            onPress={() => {
              console.log("press");
              clearWalk();
              openFilterOverlay();
            }}
            isLoading={false}
            disabled={false}
            style={showButtonText ? styles.beginButton : styles.iconOnlyButton}
            textStyle={
              Platform.OS === "web"
                ? { fontSize: 16, lineHeight: 22 }
                : { fontSize: 14, lineHeight: 20 }
            }
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  welcomeCard: {},
  welcomeContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",

    padding: 0,
    paddingBottom: 16,
    flexWrap: "nowrap", // Always keep in same row
  },
  welcomeContainerIOSMobile: {
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    padding: 0,
    paddingBottom: 16,
    gap: 12,
  },
  welcomeLeftContent: {
    flexDirection: "row",
    alignItems: "center",
    flexShrink: 1, // Allow this to shrink if needed
  },
  welcomeText: {
    fontFamily: FontFamily.bold,
    fontWeight: "700",
    fontStyle: "normal",
    fontSize: Platform.OS === "web" ? 28 : 24,
    lineHeight: Platform.OS === "web" ? 40 : 32,
    letterSpacing: 0,
    color: "#000000",
    // marginLeft: 12,
    flexShrink: 1,
  },
  beginButtonRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 10,
    alignItems: "center",
    width: "auto",
    marginTop: 0,
  },
  beginButtonRowMobile: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "auto",
    marginTop: 0,
    gap: 10,
  },
  beginButtonRowIOSMobile: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
    marginTop: 0,
    gap: 10,
  },
  beginButton: {
    width:
      Dimensions.get("window").width < 400
        ? 90
        : Platform.OS === "web"
        ? "15%"
        : 120,
    minWidth: Platform.OS === "web" ? 120 : 60,
    fontSize: Dimensions.get("window").width < 400 ? 12 : 16,
    backgroundColor: "#034895",
    borderColor: "#034895",
    height: Platform.OS === "web" ? 40 : 32,
    borderRadius: Platform.OS === "web" ? 20 : 24,
    fontFamily: FontFamily.bold,
  },
  iconOnlyButton: {
    width: 50,
    minWidth: 50,
    aspectRatio: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#034895",
    borderColor: "#034895",
    height: Platform.OS === "web" ? 40 : 32,
    borderRadius: Platform.OS === "web" ? 20 : 24,
  },
});

export default SparcWalkWelcome;
